import React from "react";
import { useNavigate } from "react-router-dom";
import logo2 from "../../assets/logos/nasos-logo-svg.svg";

const MobileTopLogo: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="mobile-top-logo">
      <img
        src={logo2}
        alt="logo"
        onClick={handleClick}
        className="mobile-top-logo-img"
      />
    </div>
  );
};

export default MobileTopLogo;

